module.exports = __webpack_public_path__ + "img/largeloader_stopped.f69b859b.svg";